import { Form, Modal } from 'semantic-ui-react';
import { Footer } from './Footer';
import {
  ErrorsContextProvider,
  ModuleBadge,
  RHFormDatePicker,
  RHFormNumberInput,
  RHFormSelect,
  ValidationErrors,
} from 'components';
import { useCreateSpeakingSession } from './useCreateSpeakingSession';
import { BaseSyntheticEvent } from 'react';
import styled from '@emotion/styled';
import { dropdownListSearch } from 'utils';

export const CreateSpeakingSession = () => {
  const {
    form,
    generalErrors,
    venueOptions,
    isFetchingVenues,
    areVenueOptionsReady,
    handleSubmit,
    isCreating,
    created,
    disabledDates,
    areDateOptionsReady,
    isFetchingDates,
  } = useCreateSpeakingSession();

  return (
    <ErrorsContextProvider generalErrors={generalErrors}>
      <Modal
        open
        as={Form}
        onSubmit={(e: BaseSyntheticEvent) => {
          form.handleSubmit(handleSubmit)(e);
        }}
      >
        <Modal.Header>Create Speaking session</Modal.Header>
        <Modal.Content>
          <ValidationErrors />
          <S.ModuleBadge />
          <RHFormDatePicker
            name="sessionDate"
            control={form.control}
            label="Date"
            disabledDates={disabledDates}
            disabled={!areDateOptionsReady}
            loading={isFetchingDates}
            data-testid="session-date"
          />
          <RHFormSelect
            name="venueId"
            control={form.control}
            label="Venue"
            options={venueOptions}
            disabled={!areVenueOptionsReady}
            loading={isFetchingVenues}
            search={dropdownListSearch}
            openOnFocus
            minCharacters={0}
          />
          <RHFormNumberInput
            label="Test taker admission time"
            name="testTakerAdmissionTimeMinutes"
            control={form.control}
            min={0}
            max={99}
            innerLabel={{ basic: true, content: 'min' }}
            innerLabelPosition="right"
          />
        </Modal.Content>
        <Footer created={created} isCreating={isCreating} />
      </Modal>
    </ErrorsContextProvider>
  );
};

const S = {
  ModuleBadge: styled(ModuleBadge)`
    &.ui.label {
      position: absolute;
      right: 1rem;
    }
  `,
};
